import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Start',
    component: () => import(/* webpackChunkName: "start" */ '../components/System/Auth/Start.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '../components/System/Auth/Login.vue'),
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/orders',
    name: 'Order list',
    component: () => import(/* webpackChunkName: "orders" */ '../components/Orders/List/OrderList.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/orders/:id',
    name: 'Order view',
    component: () => import(/* webpackChunkName: "order-view" */ '../components/Orders/View/OrderView.vue'),
    meta: {
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters['auth/isAuthorized']) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next() // go to wherever I'm going
    }
  } else {
    next() // does not require auth, make sure to always call next()!
  }
})

export default router
